module.exports = __webpack_public_path__ + "img/freewave1_feature_01.3d051a63.jpg";